import React, { forwardRef } from 'react';
import DirtyFormProxyBaseButton from '../DirtyFormProxy/DirtyFormProxyBaseButton';
import { DirtyFormProxyLinkControlled } from '../DirtyFormProxy/DirtyFormProxyLinkControlled';
import { LinkProps } from '../Link';
import { BaseButtonProps } from '../BaseButton';
import { DirtyFormProxyButtonProps } from '../DirtyFormProxy/types';
import { RouteLinkDomPropsType } from './type';

type RouteLinkDirtyElementsProps = {
	componentClasses: string;
	domProps: RouteLinkDomPropsType;
	icon?: JSX.Element;
} & LinkProps &
	BaseButtonProps &
	DirtyFormProxyButtonProps;

const RouteLinkDirtyElements = forwardRef<HTMLAnchorElement, RouteLinkDirtyElementsProps>(
	({ tagName, domProps, disabled, children, dataTestId, styledButton, componentClasses, icon, ...props }, ref) => {
		return styledButton ? (
			<DirtyFormProxyBaseButton
				{...props}
				className={componentClasses}
				disabled={disabled}
				tagName={tagName}
				dataTestId={dataTestId}
				applyOnElementProps={domProps}
				ref={ref}
				startIcon={icon}
			>
				{children}
			</DirtyFormProxyBaseButton>
		) : (
			<DirtyFormProxyLinkControlled
				className={componentClasses}
				dataTestId={dataTestId}
				{...domProps}
				ref={ref}
			>
				{children}
			</DirtyFormProxyLinkControlled>
		);
	},
);

export { RouteLinkDirtyElements };

RouteLinkDirtyElements.displayName = 'RouteLinkDirtyElements';
